interface ISSY_FORMULA {
  yearlyInvestment: number;
  startYear: number;
  rateOfInterest: number;
}

export const SSY_FORMULA = ({
  yearlyInvestment,
  startYear,
  rateOfInterest,
}: ISSY_FORMULA) => {
  if (!yearlyInvestment || !startYear || !rateOfInterest) {
    return {
      maturityYear: 0,
      totalInvestment: 0,
      maturityAmount: 0,
      interestEarned: 0,
    };
  }
  yearlyInvestment = Number(yearlyInvestment);
  startYear = Number(startYear);
  rateOfInterest = Number(rateOfInterest);
  const contributionPeriod = 15;
  const totalPeriod = 21;
  let maturityAmount = 0;

  const interestRateDecimal = rateOfInterest / 100;

  // Total amount after 15 years of contributions
  for (let i = 1; i <= contributionPeriod; i++) {
    maturityAmount += yearlyInvestment * Math.pow(1 + interestRateDecimal, i);
  }

  // Amount for the next 6 years without additional contributions
  maturityAmount *= Math.pow(
    1 + interestRateDecimal,
    totalPeriod - contributionPeriod
  );

  const totalInvestment = Math.round(yearlyInvestment * contributionPeriod);
  const interestEarned = Math.round(maturityAmount - totalInvestment);
  const maturityYear = startYear + totalPeriod;

  return {
    maturityYear,
    totalInvestment,
    maturityAmount: Math.round(maturityAmount),
    interestEarned,
  };
};
